import KeywordsGoogle from "components/keywords/KeywordsGoogle";


export default function SettingsGoogleKeywords() {
    return <KeywordsGoogle />
}